<img *ngIf="backgroundColor" [imgSrc]="backgroundImage" [takeFromLocal]="true" alt="flp360-reports-bg-img"
    class="flp360-reports-bg-img responsive ">